import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import { dateFormat } from "pages/Common"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import InvoiceDetalis from "pages/Invoices/InvoiceDetalis"
import { useSelector } from "react-redux"
import { exportDataExcel } from "pages/ExportData"
import BookingOutstandingTable from "./BookingOutstandingTable"

function BookingOutstandingReport() {
    let { pathname } = useLocation()
    const { postApi } = useApi()
    const financeAmountShowHide = useSelector(state => state.ReduxData.finaceAmountShow);

    // useStates
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [searchText, setSearchText] = useState("")
    const [displayStart, setDisplayStart] = useState(1)
    const [TotalRecords, setTotalRecords] = useState(0.0)
    const [dateDisble, setdateDisble] = useState(true)
    const { state } = useLocation();
    const [date, setdate] = useState(state == null ? [new Date(), new Date()] : [new Date(state.fromData), new Date(state.todate)])
    const [bookingId, setBookingId] = useState()
    const [modal, setModal] = useState(false)

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // return api useEffect
    useEffect(() => {
        if (date[1] != undefined) {
            bookingOutstandingReportApi()
        }
    }, [date, rowsPerPage, searchText, displayStart, dateDisble])

    // pendingBills api
    const bookingOutstandingReportApi = () => {
        setIsLoading(true)
        postApi("Report/booking-outstanding-report", {
            fromDate: !dateDisble ? null : date[0] ? dateFormat(
                date[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : date[1] ? dateFormat(
                date[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
        }).then(({ data, status }) => {
            if (status === 200) {
                setIsLoading(false)
                setTableData(data.BookingOutstandingDataList)
                setTotalRecords(data.TotalRecords)
            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    const toggle = () => {
        setModal(!modal)
    }

    // header and accessor
    const columns = useMemo(
        () => [

            {
                Header: "Bill No.",
                accessor: "BillNo",
                width: "5%",
                // Cell: ({ row }) => (
                //     <>
                //         {row.original.TotalProduct == 0 ? (
                //             <div>{row.original.BillNo}</div>
                //         ) : (
                //             <div
                //                 className="text-primary"
                //                 style={{ cursor: "pointer" }}
                //                 onClick={() => {
                //                     handleViewBookingDetails(row.original.BookingId)
                //                 }}
                //             >
                //                 {row.original.BillNo}
                //             </div>
                //         )}
                //     </>
                // ),
            },
            {
                Header: "Date",
                accessor: "BillDate",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.BillDate == null
                            ? "N/A"
                            : dateFormat(row.original.BillDate.split("T")[0], "dd/MM/yyyy")}
                    </p>
                ),
            },
            {
                Header: "Delivery Date",
                accessor: "DeliveryDate",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.DeliveryDate == null
                            ? "N/A"
                            : dateFormat(row.original.DeliveryDate.split("T")[0], "dd/MM/yyyy")}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Bill Amt.
                    </div>
                ),
                accessor: "BillAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.BillAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Receive Amt.
                    </div>
                ),
                accessor: "ReceiveAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.ReceiveAmount || 0)}
                        </div>
                    )
                },
            },
            {
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "end",
                        justifyContent: "end",
                        textAlign: "end"
                    }}
                    >
                        Due Amt.
                    </div>
                ),
                accessor: "PendingAmount",
                width: "7%",
                Cell: ({ row }) => {
                    return (
                        <div style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "end",
                            textAlign: "end"
                        }}
                        >
                            <i className="mdi mdi-currency-inr"></i>
                            {new Intl.NumberFormat('en-IN', {
                                currency: 'INR',
                                minimumFractionDigits: 2,
                            }).format(row?.original?.BillAmount - row?.original?.ReceiveAmount || 0)}
                        </div>
                    )
                },
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        setIsLoading(true)
        let header = ["Bill No.", "Date", "Delivery Date", "Bill Amt.", "Receive Amt.", "Due Amt."];
        const mainTitle = "Booking Outstanding Report";
        const widthObj = [{
            Key: "A",
            Value: 15,
        },
        {
            Key: "B",
            Value: 15,
        },
        {
            Key: "C",
            Value: 15,
        },
        {
            Key: "D",
            Value: 15,
        },
        {
            Key: "E",
            Value: 15,
        },
        {
            Key: "F",
            Value: 15,
        },
        ]
        const extention = "Booking_Outstanding_Report.xlsx"
        postApi("Report/booking-outstanding-report", {
            fromDate: !dateDisble ? null : date[0] ? dateFormat(
                date[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : date[1] ? dateFormat(
                date[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            displayStart: 1,
            pageSize: 100000,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
        }).then(({ data, status }) => {
            if (status === 200) {
                setIsLoading(false)
                let excelSheetData = []
                for (let index = 0; index < data.BookingOutstandingDataList.length; index++) {
                    let dataObj = {
                        BillNo: data.BookingOutstandingDataList[index].BillNo,
                        Date: dateFormat(data.BookingOutstandingDataList[index].BillDate.split("T")[0],
                            "dd/MM/yyyy"),
                        DeliveryDate: dateFormat(data.BookingOutstandingDataList[index].DeliveryDate.split("T")[0],
                            "dd/MM/yyyy"),
                        BillAmt: data.BookingOutstandingDataList[index].BillAmount,
                        ReceiveAmount: data.BookingOutstandingDataList[index].ReceiveAmount,
                        DueAmount: parseFloat(data.BookingOutstandingDataList[index].BillAmount) - parseFloat(data.BookingOutstandingDataList[index].ReceiveAmount),
                    }
                    excelSheetData.push(dataObj)
                }
                var fields = Object.keys(excelSheetData[0]);
                var sheetData = excelSheetData.map(function (row) {
                    return fields.map(function (fieldName) {
                        return row[fieldName];
                    });
                });
                sheetData.unshift(header);
                exportDataExcel(sheetData, mainTitle, widthObj, extention, 0, 0, 0)
            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    document.title = `Booking Outstanding | ${localStorage.getItem("ShopName")}`

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <BookingOutstandingTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            customPageSize={10}
                            isLoading={isLoading}
                            className="custom-header-css"
                            pagePerSize={pagePerSize}
                            TotalRecords={TotalRecords}
                            dateDisble={dateDisble}
                            setdateDisble={setdateDisble}
                            date={date}
                            setdate={setdate}
                            financeAmountShowHide={financeAmountShowHide}
                            writeDataToExcel={writeDataToExcel}
                        />
                    </CardBody>

                    <InvoiceDetalis
                        toggle={toggle}
                        modal={modal}
                        bookingId={bookingId}
                    />

                </Card>
            </div>
        </div>
    )
}
BookingOutstandingReport.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default BookingOutstandingReport
